//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObjectCollection.js";
import "../no/BasePart.js";
import "../Features/Features.FeatureCollection.js";
let d=[[],[[["direct_vision"],"CreateDirectVisionBuilder",{R_:{builder:"Features.DirectVisionBuilder"}},1,0],[["grid_target"],"CreateGridTargetBuilder",{R_:{builder:"Features.GridTargetBuilder"}},1,0],[["obstruction"],"CreateObstructionBuilder",{R_:{builder:"Features.ObstructionBuilder"}},1,0],[["interception"],"CreateInterceptionBuilder",{R_:{builder:"Features.InterceptionBuilder"}},1,0],[["vdvmirror"],"CreateVdvmirrorBuilder",{R_:{builder:"Features.VDVMirrorBuilder"}},1,0],[["vdvcamera"],"CreateVdvcameraBuilder",{R_:{builder:"Features.VDVCameraBuilder"}},1,0],[[],"CreateImportExportXmlbuilder",{R_:{builder:"Features.ImportExportXMLBuilder"}},0,0],[["adascoordinate_system"],"CreateAdascoordinateSystemBuilder",{R_:{builder:"Features.ADASCoordinateSystemBuilder"}},1,0],[["vdvEnvironment"],"CreateVdvenvironmentBuilder",{R_:{builder:"Features.VDVEnvironmentBuilder"}},1,0],[["environmentPainting"],"CreateEnvironmentpaintingBuilder",{R_:{builder:"Features.EnvironmentPaintingBuilder"}},1,0],[["touch_analysis"],"CreateTouchAnalysisBuilder",{R_:{builder:"Features.TouchAnalysisBuilder"}},1,0],[["rotating_pointer"],"CreateRotatingPointerBuilder",{R_:{builder:"Features.RotatingPointerBuilder"}},1,0],[["view_volume"],"CreateViewVolumeBuilder",{R_:{builder:"Features.ViewVolumeBuilder"}},1,0],[["volumetricAnalysis"],"CreateVolumetricAnalysisBuilder",{R_:{builder:"Features.VolumetricAnalysisBuilder"}},1,0]],[]];
SPLM.Features.AVDACollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Features.AVDACollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;